import { useState, useEffect } from 'react';
import { Card, Chip, Typography, Stack, TextField, Grid, Button, Box, Tooltip, IconButton, Badge, Avatar, useTheme, useMediaQuery, CircularProgress } from '@mui/material';
import Swal from 'sweetalert2';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { DataGrid,useGridApiRef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useForm, FormProvider, Controller, set } from 'react-hook-form';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { CheckCircle, Warning, Pending, ArrowBack, Map, Download } from '@mui/icons-material';
import { formatDateTime } from '../../../../utils/dateUtils';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import NoRowsLayout from '../../../../components/Layout/NoRowsLayout';
import Loading from '../../../../components/Loader/Loading';
import MultiColumnFilter from '../../../../components/Filter/MultiColumnFilter';
import ExportAll from './ExportAll';
import { TaxService } from '../TaxService';
import stateList from '../../../../utils/stateList.json'
import dayjs from 'dayjs';
import pdfLogo from "../../../../assets/images/pdf-icon-4.png";

//list of years current and last 3 years
const years = [
  dayjs().format('YYYY'),
  dayjs().subtract(1, 'year').format('YYYY'),
  dayjs().subtract(2, 'year').format('YYYY'),  
  dayjs().subtract(3, 'year').format('YYYY'),
];

const SumarryList = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const downloadInvoice = async (id) => {
        Swal.fire({
        title: 'Generating Invoice...',
        html: 'Please wait while the invoice is being generated.',
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        },
        });
        const response = await TaxService.downloadwalletSummaryInvoice(id);
        if(response.success == '1'){
        // {
        //     "success": true,
        //     "fileUrl": "https://cudel.s3.amazonaws.com/staging/pdf/subscriptionInvoice/INV-65_28_1766542878400.pdf"
        // }
        const result =await Swal.fire({
            title: 'Invoice Generated',
            text: 'Your invoice has been generated successfully.',
            icon: 'success',
            confirmButtonText: 'View Invoice',
            allowOutsideClick: false,
        })
        if(result.isConfirmed){
            window.open(response.fileUrl, '_blank');
        }
        }else{
        Swal.fire({
            title: 'Error',
            text: 'Failed to generate invoice. Please try again later.',
            icon: 'error',
            confirmButtonText: 'OK'
        });
        }
    };
    const columns=[
            { field: 'invoiceNumber', headerName: 'Invoice No.', width: 180, sortable:false,headerAlign: 'left', align: 'left',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Invoice No.</span>,
                renderCell: (params) =>(
                    <Box sx={{ display: 'flex', width:'100%',alignItems:'center',gap:1 }}>
                    <Typography color="primary" sx={{fontSize:'.65rem',cursor:'pointer'}} 
                        onClick={() => downloadInvoice(params.row.id)}
                    >
                        {params.value}
                        {/* {' '} */}
                        {/* {params.row.customerId == params.row.createdBy && <PhoneAndroid sx={{fontSize:'.65rem'}} color='warning'/>} */}
                    </Typography>
                    <img
                        src={pdfLogo}
                        alt="download_pdf_logo"
                        style={{ width: "1rem", height: "1rem", cursor: "pointer" }}
                        onClick={() => downloadInvoice(params.row.id)}
                    />
                    </Box>
                )
            },
            { field: 'expert', headerName: 'Expert', width: 150, sortable:false,headerAlign: 'left', align: 'left',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Expert</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', width:'100%' }}>
                        <Typography sx={{textTransform:'capitalize',fontSize: '.65rem', fontWeight: 500}}> 
                            {`${params.row?.expert?.UserProfile?.firstName || ''} ${params.row?.expert?.UserProfile?.middleName || ''} ${params.row?.expert?.UserProfile?.lastName || ''}`}
                            <Box component={'span'} sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>({params.row.expertId})</Box>
                        </Typography>
                    </Box>
                )
            },
            { field: 'state', headerName: 'State', width: 120, sortable:false,headerAlign: 'left', align: 'left',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>State</span> ,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.65rem'}}>{params.row.expert.UserAddress.state}
                            <Box component={'span'} sx={{ fontSize: '.55rem', fontWeight: 600, color: '#382cd5' }}>({stateList.find(s => s.name == params.row?.expert?.UserAddress?.state)?.code})</Box>
                            </Typography>
                    </Box>
                )
            },
            { field: 'monthYear', headerName: 'Month/Year', width: 110, sortable:false,headerAlign: 'left', align: 'left',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Month/Year</span>,
                // valueFormatter: (params) => ,
                renderCell: (params) => {
                    const monthName = params.row?.month
                        ? new Date(params.row.year, params.row.month - 1).toLocaleString('default', { month: 'short' })
                        : '';
                    return (
                        <Box sx={{ display: 'flex', width: '100%' }}>
                            <Typography variant="body2" sx={{ textTransform: 'capitalize', fontSize: '.75rem' }}>
                                {monthName}, {params.row.year}
                            </Typography>
                        </Box>
                    );
                }
            },
            { field: 'serviceName', headerName: 'Service Name', width: 160, sortable:false,headerAlign: 'left', align: 'left',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Service Name</span> ,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>Subscription Charge</Typography>
                    </Box>
                )
            },
            { field: 'baseAmount', headerName: 'Base Amt', width: 90, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Base Amt</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'discountAmount', headerName: 'Discount', width: 90, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Discount</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{(parseFloat(params.value)).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'taxableAmount', headerName: 'Taxable Amt', width: 100, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Taxable Amt</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'cgst', headerName: 'CGST', width: 80, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>CGST</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'sgst', headerName: 'SGST', width: 80, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>SGST</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                ) 
            },
            { field: 'igst', headerName: 'IGST', width: 80, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>IGST</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'totalTax', headerName: 'Total GST', width: 95, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total GST</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'billingAmount', headerName: 'Final Amt', width: 100, sortable:false,headerAlign: 'center', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total Amt</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"center",justifyContent:'center', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{parseFloat(params.value).toFixed(2)}</Typography>
                    </Box>
                )
            },
            { field: 'taxRate', headerName: 'Tax Rate', width: 90, sortable:false,headerAlign: 'right', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Tax Rate</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>18%</Typography>
                    </Box>
                )
            },
            { field: 'openingBalance', headerName: 'Opening Balance', width: 150, sortable:false,headerAlign: 'right', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Opening Balance</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{params.value}</Typography>
                    </Box>
                )
            },
            { field: 'totalDebitAmount', headerName: 'Tax Rate', width: 150, sortable:false,headerAlign: 'right', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total Debit</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{params.value}</Typography>
                    </Box>
                )
            },
            { field: 'totalCreditAmount', headerName: 'Tax Rate', width: 150, sortable:false,headerAlign: 'right', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Total Credit</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{params.value}</Typography>
                    </Box>
                )
            },
            { field: 'closingBalance', headerName: 'Tax Rate', width: 100, sortable:false,headerAlign: 'right', align: 'right',
                renderHeader: () => <span style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Closing Balance</span>,
                renderCell: (params) => (
                    <Box sx={{ display: 'flex', alignItems:"right",justifyContent:'right', width:'100%' }}>
                        <Typography variant="body2" sx={{textTransform:'capitalize',fontSize:'.75rem'}}>₹{params.value}</Typography>
                    </Box>
                )
            },
        ]
    // Initialize paginationModel state with potential localStorage backup
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
        filters: {
            searchKey: "",
            sortBy: 'updatedAt',
            sortType: 'desc',
            filterOptions: [
                // {
                // "fieldName": "profile",
                // "operator": "equals",
                // "value": "complete"
                // },
                // {
                //   "fieldName": "isTester",
                //   "operator": "equals",
                //   "value": "false",
                //   "andOr": "and"
                // }
            ],
        }
        // };
    });
    // State management
    const [allRowCount, setAllRowCount] = useState(0);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [zipLoading, setZipLoading] = useState(false);

    const downloadBlob = (blob, fileName) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    };

    const handleDownloadZipPdfs = async () => {
        if (!allRowCount) {
            Swal.fire({
                title: 'No PDFs Found',
                text: 'There are no wallet invoices for the current filters.',
                icon: 'info',
                confirmButtonText: 'OK',
            });
            return;
        }

        const result = await Swal.fire({
            title: `Export ${allRowCount} PDF${allRowCount > 1 ? 's' : ''} as ZIP?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Export ZIP',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
        });

        if (!result.isConfirmed) return;

        setZipLoading(true);
        Swal.fire({
            title: 'Preparing PDF ZIP...',
            html: `<p>Preparing ${allRowCount} PDF${allRowCount > 1 ? 's' : ''} on server...</p>`,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
        });

        let response;
        try {
            response = await TaxService.downloadWalletSummaryInvoiceZip({
                filters: {
                    searchKey: paginationModel.filters.searchKey,
                    sortBy: paginationModel.filters.sortBy,
                    sortType: paginationModel.filters.sortType,
                    filterOptions: paginationModel.filters.filterOptions || []
                }
            });
        } catch (error) {
            console.error('Wallet invoice ZIP download failed', error);
            setZipLoading(false);
            Swal.fire({
                title: 'Export Failed',
                text: 'Unable to download wallet invoice PDFs.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
            return;
        }

        setZipLoading(false);

        if (!response?.success) {
            Swal.fire({
                title: 'Export Failed',
                text: response?.message || 'Unable to download wallet invoice PDFs.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
            return;
        }

        downloadBlob(response.blob, `expert-wallet-invoices-${dayjs().format('YYYY-MM-DD-HHmmss')}.zip`);

        const exportedPdfs = Number(response.exportedPdfs || allRowCount);
        const failedPdfs = Number(response.failedPdfs || 0);
        Swal.fire({
            title: failedPdfs ? 'ZIP Downloaded with Some Missing PDFs' : 'ZIP Downloaded',
            text: failedPdfs
                ? `${exportedPdfs} PDF(s) exported. ${failedPdfs} PDF(s) could not be added.`
                : `${exportedPdfs} PDF(s) exported successfully.`,
            icon: failedPdfs ? 'warning' : 'success',
            confirmButtonText: 'Close',
        });
    };

    const fetchSummaryList = async () => {
        setLoading(true);
        try {
            const response = await TaxService.fetchWalletSummaryList({
                page: paginationModel.page,
                limit: paginationModel.pageSize,
                filters: {
                    searchKey: paginationModel.filters.searchKey,
                    sortBy: paginationModel.filters.sortBy,
                    sortType: paginationModel.filters.sortType,
                    filterOptions: paginationModel.filters.filterOptions || []
                }
            });
            if(response.success == '1'){
                setList(response.data.list);
                setAllRowCount(response.data.totalItems);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Something went wrong while fetching data.',
            })
        }
    }
    useEffect(() => {
        fetchSummaryList();
    }, [paginationModel]);

    // Pagination change handler
    const handlePaginationChange = (newPagination) => {
        setPaginationModel(prev => ({
        ...prev,
        page: newPagination.page,
        pageSize: newPagination.pageSize
        }));
    };
    // Form handling for filters
      const filterFormMethod = useForm();
      const { control, handleSubmit, reset, setValue, getValues, formState: { errors }, watch } = filterFormMethod;
    
      // Filter submission handler
      function onSubmit(data) {
        const filtersData = getValues();
        setPaginationModel(prev => ({
          ...prev,
          filters: {
            ...prev.filters,
            searchKey: filtersData.searchKey,
          }
        }));
      }
    
      // Clear filters handler
      const clearFilters = () => {
        reset();
        setPaginationModel(prev => ({
          ...prev,
          filters: {
            searchKey: "",
            sortBy: 'createdAt',
            sortType: 'desc',
            filterOptions: []
          }
        }));
    
        // Trigger clear for MultiColumnFilter
        setClearMultiFilter(true);
    
        // Reset the clear trigger after a short delay
        setTimeout(() => setClearMultiFilter(false), 100);
    };
    /************************  Advance Filter **************************** */
    
    
      const [clearMultiFilter, setClearMultiFilter] = useState(false);
    
      const filterableColumns = [
        {
          key: 'month',
          label: 'Month',
          type: 'select',
          options: [
            { value: '1', label: 'January' },
            { value: '2', label: 'February' },
            { value: '3', label: 'March' },
            { value: '4', label: 'April' },
            { value: '5', label: 'May' },
            { value: '6', label: 'June' },
            { value: '7', label: 'July' },
            { value: '8', label: 'August' },
            { value: '9', label: 'September' },
            { value: '10', label: 'October' },
            { value: '11', label: 'November' },
            { value: '12', label: 'December' }

          ]
        },
        {
          key: 'year',
          label: 'Year',
          type: 'select',
          options: years.map(year => ({ value: year, label: year }))
        },
      ];
    
      const handleApplyFilter = (filterData) => {
        // Process filter data
        console.log(filterData);
        setPaginationModel({
          ...paginationModel,
          page: 0, // Reset to first page when applying new filters
          filters: {
            ...paginationModel.filters,
            // Convert MultiColumnFilter options to a format your backend can understand
            filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
          }
        });
      }
    
      /************* quick search related **************/
      const [quickFilterText, setQuickFilterText] = useState('');
      // Properly structured filter model
      const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterValues: []
      });
    
      // Update filter model when quick filter text changes
      useEffect(() => {
        setFilterModel(prevModel => ({
          ...prevModel,
          quickFilterValues: quickFilterText ? [quickFilterText] : []
        }));
      }, [quickFilterText]);
    
      /******************* Sorting model  ******************************/
      const [sortModel, setSortModel] = useState([
        {
          field: paginationModel.filters.sortBy,
          sort: paginationModel.filters.sortType,
        },
      ]);
    
      const handleSortingChange = (newSortModel) => {
        console.log("new sort model", newSortModel);
        if (newSortModel && newSortModel.length > 0) {
          setSortModel(newSortModel);
          setPaginationModel(prev => ({
            ...prev,
            filters: {
              ...prev.filters,
              sortBy: newSortModel[0].field,
              sortType: newSortModel[0].sort
            }
          }));
        }
        // else{
        //   setSortModel([{
        //     field: 'createdAt',
        //     sort: 'asc',
        //   }]);
        //   setPaginationModel(prev => ({
        //     ...prev,
        //     filters: {
        //       ...prev.filters,
        //       sortBy: 'createdAt',
        //       sortType: 'asc'
        //     }
        //   }));
        // }
    }
  return (
    <>
      {loading && <Loading />}
      
      {/*  */}

      <Card sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff" }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <MultiColumnFilter
                filterableColumns={filterableColumns}
                onApplyFilter={handleApplyFilter}
                externalClear={clearMultiFilter}
                defaultFilterOptions={[
                //   {
                //     "fieldName": "profile",
                //     "operator": "equals",
                //     "value": "complete"
                //   }
                ]}
                alwaysKeepDefaultFilterOption={true}
              />
              <ExportAll
                paginationModel={paginationModel}
                columns={columns}
              />
              <Button
                onClick={handleDownloadZipPdfs}
                disabled={zipLoading || !allRowCount}
                startIcon={zipLoading ? <CircularProgress size={16} color="inherit" /> : <Download />}
                sx={{ textTransform: 'none' }}
              >
                {zipLoading ? 'Preparing PDFs...' : 'Download PDFs'}
              </Button>
            </Box>
            {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} />             */}
            <Box sx={{width:{xs:'75%',sm:'40%',md:'30%',lg:'25%'}}}>
              {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
              <FormProvider {...filterFormMethod}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={1} sx={{ p: '.5%' }}>
                    <Grid item xs={9} lg={8}>
                      <Controller
                        name="searchKey"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <TextField
                            {...field}
                            placeholder="Search by invoice number only "
                            // label="Search"
                            size="small"
                            fullWidth
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                paddingLeft: '0px',
                              }
                            }}
                            InputProps={{  // Changed from slotProps to InputProps
                              inputProps: {
                                style: {
                                  height: '0.6rem',
                                  textTransform: 'uppercase',
                                  fontSize: 'x-small'
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={3} lg={4}>
                      <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                        <IconButton
                          size='small'
                          color="primary"
                          type="submit"
                          sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                        >
                          <SearchIcon sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Clear All Filters">
                        <IconButton
                          size='small'
                          color="primary"
                          sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                          onClick={clearFilters}
                        >
                          <RestartAltIcon sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </form>
              </FormProvider>
            </Box>
            
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: isSmallScreen && (col.flex || 1), // Ensure columns resize dynamically
              minWidth: isSmallScreen && (col.minWidth || 180), // Set a minimum width to avoid overlap
            }))}
            rowCount={allRowCount}
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}
            filterModel={filterModel}


            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loading}
            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,   
              loadingOverlay: Loading,
              noRowsOverlay: NoRowsLayout,
            }}
            getRowHeight={() => 'auto'}
            sx={{
                 minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                        "& .MuiDataGrid-root": {
                        overflowX: "auto",
                        },
                  height:'68vh',
                    borderRadius:'0',
                    '& .MuiDataGrid-cell': {
                    border: 1,
                    borderRight: 0,
                    borderTop: 0,
                    borderColor: 'lightgrey',
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                    //   borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        minHeight:'0 !important',
                        height:'2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    borderBottom: 'none',
                    '&:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 600,
                    color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '& .MuiDataGrid-cell': {
                            py:1
                        },
                        // Add styles for deleted rows
                        '&.deleted-row': {
                            backgroundColor: '#ffebee !important', // Light red background
                            '&:hover': {
                            backgroundColor: '#ffcdd2 !important', // Darker red on hover
                            }
                        },
                        '& .MuiDataGrid-cell:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    },
                    '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                    },
                }}
          />
        </Box>
      </Card>
    </>
  )
}

export default SumarryList
